const paymentActions = {
  CREATE_PAYMENT_BEGIN: "CREATE_PAYMENT_BEGIN",
  CREATE_PAYMENT_SUCCESS: "CREATE_PAYMENT_SUCCESS",
  CREATE_PAYMENT_ERR: "CREATE_PAYMENT_ERR",

  LIST_PAYMENTS_BEGIN: "LIST_PAYMENTS_BEGIN",
  LIST_PAYMENTS_SUCCESS: "LIST_PAYMENTS_SUCCESS",
  LIST_PAYMENTS_ERR: "LIST_PAYMENTS_ERR",

  UPDATE_PAYMENT_BEGIN: "UPDATE_PAYMENT_BEGIN",
  UPDATE_PAYMENT_SUCCESS: "UPDATE_PAYMENT_SUCCESS",
  UPDATE_PAYMENT_ERR: "UPDATE_PAYMENT_ERR",

  DELETE_PAYMENT_BEGIN: "DELETE_PAYMENT_BEGIN",
  DELETE_PAYMENT_SUCCESS: "DELETE_PAYMENT_SUCCESS",
  DELETE_PAYMENT_ERR: "DELETE_PAYMENT_ERR",

  PROCESS_PAYMENT_BEGIN: "PROCESS_PAYMENT_BEGIN",
  PROCESS_PAYMENT_SUCCESS: "PROCESS_PAYMENT_SUCCESS",
  PROCESS_PAYMENT_ERR: "PROCESS_PAYMENT_ERR",

  REFUND_PAYMENT_BEGIN: "REFUND_PAYMENT_BEGIN",
  REFUND_PAYMENT_SUCCESS: "REFUND_PAYMENT_SUCCESS",
  REFUND_PAYMENT_ERR: "REFUND_PAYMENT_ERR",

  GET_PAYMENT_DETAILS_BEGIN: "GET_PAYMENT_DETAILS_BEGIN",
  GET_PAYMENT_DETAILS_SUCCESS: "GET_PAYMENT_DETAILS_SUCCESS",
  GET_PAYMENT_DETAILS_ERR: "GET_PAYMENT_DETAILS_ERR",

  createPaymentBegin: () => {
    return {
      type: paymentActions.CREATE_PAYMENT_BEGIN,
    };
  },

  createPaymentSuccess: (data) => {
    return {
      type: paymentActions.CREATE_PAYMENT_SUCCESS,
      data,
    };
  },

  createPaymentErr: (err) => {
    return {
      type: paymentActions.CREATE_PAYMENT_ERR,
      err,
    };
  },

  listPaymentsBegin: () => {
    return {
      type: paymentActions.LIST_PAYMENTS_BEGIN,
    };
  },

  listPaymentsSuccess: (data) => {
    return {
      type: paymentActions.LIST_PAYMENTS_SUCCESS,
      data,
    };
  },

  listPaymentsErr: (err) => {
    return {
      type: paymentActions.LIST_PAYMENTS_ERR,
      err,
    };
  },

  updatePaymentBegin: () => {
    return {
      type: paymentActions.UPDATE_PAYMENT_BEGIN,
    };
  },

  updatePaymentSuccess: (data) => {
    return {
      type: paymentActions.UPDATE_PAYMENT_SUCCESS,
      data,
    };
  },

  updatePaymentErr: (err) => {
    return {
      type: paymentActions.UPDATE_PAYMENT_ERR,
      err,
    };
  },

  deletePaymentBegin: () => {
    return {
      type: paymentActions.DELETE_PAYMENT_BEGIN,
    };
  },

  deletePaymentSuccess: (data) => {
    return {
      type: paymentActions.DELETE_PAYMENT_SUCCESS,
      data,
    };
  },

  deletePaymentErr: (err) => {
    return {
      type: paymentActions.DELETE_PAYMENT_ERR,
      err,
    };
  },

  processPaymentBegin: () => {
    return {
      type: paymentActions.PROCESS_PAYMENT_BEGIN,
    };
  },

  processPaymentSuccess: (data) => {
    return {
      type: paymentActions.PROCESS_PAYMENT_SUCCESS,
      data,
    };
  },

  processPaymentErr: (err) => {
    return {
      type: paymentActions.PROCESS_PAYMENT_ERR,
      err,
    };
  },

  refundPaymentBegin: () => {
    return {
      type: paymentActions.REFUND_PAYMENT_BEGIN,
    };
  },

  refundPaymentSuccess: (data) => {
    return {
      type: paymentActions.REFUND_PAYMENT_SUCCESS,
      data,
    };
  },

  refundPaymentErr: (err) => {
    return {
      type: paymentActions.REFUND_PAYMENT_ERR,
      err,
    };
  },

  getPaymentDetailsBegin: () => {
    return {
      type: paymentActions.GET_PAYMENT_DETAILS_BEGIN,
    };
  },

  getPaymentDetailsSuccess: (data) => {
    return {
      type: paymentActions.GET_PAYMENT_DETAILS_SUCCESS,
      data,
    };
  },

  getPaymentDetailsErr: (err) => {
    return {
      type: paymentActions.GET_PAYMENT_DETAILS_ERR,
      err,
    };
  },
};

export default paymentActions;
